import { Stack } from "@mui/material";
import { format } from "date-fns";
import FilterChip from "./FilterChip";
import { useBoundStore } from "useStore";

export default function DateFilterChip() {
  const searchObject = useBoundStore((state) => state.soAdminSearch);
  const setSearchObject = useBoundStore((state) => state.setSoAdminSearch);

  const { startDate, endDate } = searchObject;

  if (!startDate && !endDate) return null;

  const formatDate = (date) => format(new Date(date), "dd/MM/yyyy");

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {startDate && (
        <FilterChip
          filterName="Desde"
          title={formatDate(startDate)}
          onDelete={() => setSearchObject({ ...searchObject, startDate: null })}
        />
      )}
      {endDate && (
        <FilterChip
          filterName="Hasta"
          title={formatDate(endDate)}
          onDelete={() => setSearchObject({ ...searchObject, endDate: null })}
        />
      )}
    </Stack>
  );
}
